import {
    ELUSIVEDATA_SET,
    ELUSIVEDATA_UNSET,
    ELUSIVEDATA_CLEAR,
    ELUSIVEDATA_CLEAR_SUBPANELS, ELUSIVEDATA_CLEAR_ALL
} from '../constants';

export type DataIdList = {
    items : { [ id : number ] : number };
    references : { [ id : number ] : number };
}

export type ElusiveData = {
    data? : Partial<DataIdList> & { [ key : string ] : any };
    metaData? : Partial<DataIdList> & { [ key : string ] : any };
    lastParams? : string | { [ key : string ] : any };
} & { [ key : string ] : any };

export type SetElusiveDataAction = {
    type : typeof ELUSIVEDATA_SET;
    panelKey : string;
    data : ElusiveData;
}

/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 * @param {any} data
 *
 * @return {SetElusiveDataAction}
 */
export function setElusiveData( panelKey : string, data : any ) : SetElusiveDataAction {
    return {
        type: ELUSIVEDATA_SET,
        panelKey,
        data
    };
}

export type SetElusiveData = typeof setElusiveData;


export type UnsetElusiveDataAction = {
    type : typeof ELUSIVEDATA_UNSET;
    panelKey : string;
    keys : string[];
}

/**
 * @memberOf! Actions
 *
 * @param {string} panelKey
 * @param {string[]} keys
 *
 * @return {UnsetElusiveDataAction}
 */
export function unsetElusiveData( panelKey : string, keys : string[] ) : UnsetElusiveDataAction {
    return {
        type: ELUSIVEDATA_UNSET,
        panelKey,
        keys
    };
}

export type UnsetElusiveData = typeof unsetElusiveData;


export type ClearElusiveDataAction = {
    type : typeof ELUSIVEDATA_CLEAR;
    panelKey : string;
}

/**
 * @memberOf! Actions
 *
 * @param {string} panelKey
 *
 * @return {ClearElusiveDataAction}
 */
export function clearElusiveData( panelKey : string ) : ClearElusiveDataAction {
    return {
        type: ELUSIVEDATA_CLEAR,
        panelKey
    };
}

export type ClearElusiveData = typeof clearElusiveData;


export type ClearAllElusiveDataAction = {
    type : typeof ELUSIVEDATA_CLEAR_ALL;
}

/**
 * @memberOf! Actions
 *
 * @return {ClearAllElusiveDataAction}
 */
export function clearAllElusiveData() : ClearAllElusiveDataAction {
    return {
        type: ELUSIVEDATA_CLEAR_ALL
    };
}

export type ClearAllElusiveData = typeof clearAllElusiveData;


export type ClearElusiveDataForSubpanelsAction = {
    type : typeof ELUSIVEDATA_CLEAR_SUBPANELS;
    panelKey : string;
}

/**
 * @memberOf! Actions
 *
 * @param {string} panelKey
 *
 * @return {ClearElusiveDataForSubpanelsAction}
 */
export function clearElusiveDataForSubpanels( panelKey : string ) : ClearElusiveDataForSubpanelsAction {
    return {
        type: ELUSIVEDATA_CLEAR_SUBPANELS,
        panelKey
    };
}

export type ClearElusiveDataForSubpanels = typeof clearElusiveDataForSubpanels;
